<template>
  <div class="item" :class="itemClass" ref="heroItem">
    <div class="image-box">
      <img :src="img1Path" alt="" class="image-01" v-if="loadImages" @load="loadCount++;">
      <img :src="img2Path" alt="" class="image-02" v-if="loadImages" @load="loadCount++;">
    </div>
    <div class="text-box">
      <h4>{{date}}</h4>
      <p>{{description}}</p>
      <a :href="link" target="_blank"></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TimelineHero",
    props: {
      image1: {
        type: String
      },
      image2: {
        type: String
      },
      date: {
        type: String
      },
      description: {
        type: String
      },
      type: {
        type: String
      },
      link: {
        type: String,
        default: '#'
      }
    },
    data() {
      return {
        img1Path: require('../assets/images/timeline/' + this.image1),
        img2Path: require('../assets/images/timeline/' + this.image2),
        loadCount: 0,
        loadImages: false
      }
    },
    computed: {
      itemClass() {
        let c = this.type;
        if (this.loadCount === 2) {
          c += ' ' + 'show';
        }
        return c;
      }
    },
    methods: {
      checkObserver() {
        if (window["IntersectionObserver"]) {
          this.createObserver();
        } else {
          this.loadImages = true;
        }
      },
      createObserver() {
        const item = this.$refs.heroItem;
        const options = {
          root: null,
          threshold: 0.5
        };
        const observer = new IntersectionObserver(this.handleIntersect, options);
        observer.observe(item);
      },
      handleIntersect(intersection) {
        if (intersection[0].isIntersecting) {
          this.loadImages = true;
        }
      }
    },
    mounted() {
      this.checkObserver();
    }
  }
</script>

<style scoped>
  .item {
    position: relative;
    color: white;
    white-space: normal;
    z-index: 1;
  }
  .item:not(.show) .image-box {
    min-height: 200px;
  }
  .text-box {
    position: absolute;
    width: 260px;
    transition: 0.6s cubic-bezier(0.33, 1, 0.68, 1) 0.3s;
    opacity: 0;
    transform: translate3d(0, 140px, 0);
  }
  h4 {
    font-size: 12px;
    font-weight: 500;
  }
  h4, p {
    margin: 6px 0;
  }
  p {
    font-size: 20px;
    line-height: 1.4;
  }
  a {
    position: relative;
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 3px solid white;
    margin: 20px -2px 2px;
    overflow: hidden;
  }
  a:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(./../assets/images/arrow-link.svg);
    transform: translate3d(-30%, 0, 0);
    transition: 0.2s ease;
  }
  a:hover:after {
    transform: translate3d(-15%, 0, 0);
  }
  .image-01 {
    position: relative;
    display: block;
    width: 100%;
    transition: 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0s;
    opacity: 0;
    transform: translate3d(200px, 0, 0);
  }
  .image-02 {
    position: absolute;
    transition: 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.1s;
    opacity: 0;
    transform: translate3d(0, 200px, 0);
  }
  .show .image-01, .show .image-02, .show .text-box {
    opacity: 1 !important;
    transform: translate3d(0, 0, 0) !important;
  }
  .hero-01 {
    position: relative;
    left: -100px;
    margin-bottom: 8vh;
    width: 360px;
    height: 360px;
    max-width: 40vh;
    max-height: 40vh;
  }
  .hero-01 .image-02 {
    height: 225px;
    max-height: 25vh;
    left: -50%;
    top: 24%;
  }
  .hero-01 .text-box {
    left: 100%;
    bottom: 0;
    margin: 0 30px;
  }
  @media(max-width: 999px) {
    .hero-01 {
      width: 220px;
      height: 220px;
      max-width: none;
      margin: 0;
      top: -60px;
    }
    .hero-01 .image-02 {
      height: 140px;
      left: -50%;
      top: 24%;
    }
    .hero-01 .text-box {
      margin: 0 22px;
    }
  }
  .hero-02 {
    margin: -32vh 20vh -32vh 2vh;
    min-width: 38.5vh;
  }
  .hero-02 .image-01 {
    height: 100vh;
    width: auto;
    top: 2.5vh;
  }
  .hero-02 .image-02 {
    height: 30vh;
    bottom: 28vh;
    left: 16vh;
  }
  .hero-02 .text-box {
    left: 100%;
    top: 71vh;
    margin: 30px;
  }
  @media(max-width: 999px) {
    .hero-02 {
      margin: 0 170px 0 0;
      height: 500px;
      top: 0;
      min-width: 210px;
    }
    .hero-02 .image-01 {
      height: 540px;
      top: 0;
    }
    .hero-02 .image-02 {
      height: 170px;
      bottom: 180px;
      left: 120px;
      top: auto;
    }
    .hero-02 .text-box {
      margin: 0 20px 4px;
      top: auto;
    }
  }
  .hero-03 {
    position: relative;
    display: inline-block;
    margin: -32vh 10vh 0 16vh;
    vertical-align: top;
    min-width: 47vh;
  }
  .hero-03 .image-01 {
    height: 62vh;
    width: auto;
  }
  .hero-03 .image-02 {
    height: 28vh;
    top: 22vh;
    left: -12vh;
  }
  .hero-03 .text-box {
    position: relative;
    margin: 20px;
  }
  @media(max-width: 999px) {
    .hero-03 {
      margin: -60px 50px 0 70px;
      min-width: 0;
    }
    .hero-03 .image-01 {
      height: 300px;
    }
    .hero-03 .image-02 {
      height: 150px;
      top: 30px;
      left: -70px;
    }
    .hero-03 .text-box {
      margin-left: 0;
      margin-right: -100px;
    }
  }
  .hero-04 {
    position: relative;
    display: inline-block;
    margin: -27vh 340px 0 16vh;
    vertical-align: top;
    min-width: 37.1vh;
  }
  .hero-04 .image-01 {
    height: 58vh;
    width: auto;
  }
  .hero-04 .image-02 {
    height: 24vh;
    top: 16vh;
    left: -16vh;
  }
  .hero-04 .text-box {
    position: absolute;
    left: 100%;
    bottom: 34vh;
    margin-left: 30px;
  }
  @media(max-width: 999px) {
    .hero-04 {
      height: 360px;
      margin: -170px 280px 0 120px;
      min-width: 0;
    }
    .hero-04 .image-01 {
      height: 360px;
    }
    .hero-04 .image-02 {
      height: 160px;
      left: -100px;
      top: 90px;
    }
    .hero-04 .text-box {
      bottom: 210px;
      margin-left: 20px;
      width: 200px;
    }
  }
  .hero-05 {
    position: relative;
    display: inline-block;
    margin: -16vh 50px 0 20vh;
    vertical-align: top;
    min-width: 33.5vh;
  }
  .hero-05 .image-01 {
    height: 58vh;
    width: auto;
  }
  .hero-05 .image-02 {
    height: 24vh;
    top: 12vh;
    left: -16vh;
  }
  .hero-05 .text-box {
    position: absolute;
    right: 100%;
    bottom: 42vh;
    margin: 40px;
  }
  .hero-05 a {
    position: absolute;
    right: 100%;
    margin-right: 20px;
    top: 13px;
  }
  @media(max-width: 999px) {
    .hero-05 {
      margin: -160px 10px 0 210px;
      min-width: 0;
    }
    .hero-05 .image-01 {
      height: 350px;
    }
    .hero-05 .image-02 {
      height: 160px;
      left: -100px;
      top: 100px;
    }
    .hero-05 .text-box {
      margin: 0 5px;
      width: 220px;
      bottom: auto;
      top: 0;
    }
  }
  .hero-06 {
    margin: -48vh 10vh -32vh 4vh;
    min-width: 38.4vh;
  }
  .hero-06 .image-01 {
    height: 100vh;
    width: auto;
    top: 2.5vh;
  }
  .hero-06 .image-02 {
    height: 28vh;
    top: 40vh;
    left: 22vh;
  }
  .hero-06 .text-box {
    left: 100%;
    bottom: 60vh;
    margin: 30px;
    width: 300px;
  }
  @media(max-width: 999px) {
    .hero-06 {
      margin: 0 140px 0 20px;
      min-width: 0;
    }
    .hero-06 .image-01 {
      height: 500px;
      top: -180px;
    }
    .hero-06 .image-02 {
      top: -30px;
      height: 180px;
      left: 90px;
    }
    .hero-06 .text-box {
      bottom: 100%;
      margin: 50px 20px;
    }
  }
  .hero-07 {
    position: relative;
    display: inline-block;
    margin: -36vh 22vh 0 20px;
    vertical-align: top;
    min-width: 36.6vh;
  }
  .hero-07 .image-01 {
    height: 54vh;
    width: auto;
  }
  .hero-07 .image-02 {
    height: 22vh;
    top: 24vh;
    left: 17vh;
  }
  .hero-07 .text-box {
    position: absolute;
    left: 100%;
    top: 0;
    margin: -5px 30px;
    width: 300px;
  }
  @media(max-width: 999px) {
    .hero-07 {
      margin: -200px 140px 0 20px;
      min-width: 0;
    }
    .hero-07 .image-01 {
      height: 340px;
    }
    .hero-07 .image-02 {
      height: 145px;
      top: 155px;
      left: 100px;
    }
    .hero-07 .text-box {
      margin: -3px 22px;
    }
  }
  .hero-08 {
    position: relative;
    display: inline-block;
    margin: -28vh 18vh 0 22vh;
    vertical-align: top;
    min-width: 55vh;
  }
  .hero-08 .image-01 {
    height: 40vh;
    width: auto;
  }
  .hero-08 .image-02 {
    height: 24vh;
    top: 24vh;
    left: -10vh;
  }
  .hero-08 .text-box {
    position: absolute;
    left: 26vh;
    top: 100%;
    margin: 30px;
    width: 300px;
  }
  @media(max-width: 999px) {
    .hero-08 {
      margin: -170px 160px 0 180px;
      min-width: 285px;
    }
    .hero-08 .image-01 {
      height: 240px;
    }
    .hero-08 .image-02 {
      height: 160px;
      top: 148px;
      left: auto;
      right: 110px;
    }
    .hero-08 .text-box {
      margin: 12px -90px;
      width: 200px;
      left: 100%;
    }
  }
  @media(max-width: 999px), (max-height: 799px) {
    p {
      font-size: 16px;
      min-height: 0;
    }
    a {
      border: 2px solid white;
      width: 40px;
      height: 40px;
      margin-top: 14px;
    }
  }
</style>